import { CriteriaBase } from "@/shared/models/CriteriaBase.model";
import { StatutMandat } from "@/shared/enums/StatutMandat.enum";

/**
 * Liste des filtres possible pour récupérer la liste des Mandats.
 */
export class MandatCriteria extends CriteriaBase {
    /**
     * La date de signature.
     */
    public dateSignature: string | null = null;

    /**
     * La date de début.
     */
    public dateDebut: string | null = null;

    /**
     * La date de fin.
     */
    public dateFin: string | null = null;

    /**
     * L'ensemble des contrats d'achat (installations) liés aux factures.
     */
    public ContratAchatGroupeIds: number[];

    /**
     * Le statut du mandat.
     */
    public statut: StatutMandat ;

    /**
     * L'identifiant de l'utilisateur sélectionné
     */
    public utilisateurId: number | null = null;

    /**
     * Initialise les valeurs par défaut du filtre de factures.
     */
    constructor() {
        super();
        this.ContratAchatGroupeIds = [];
    }
}
